module.exports = Em.Handlebars.compile("<section class=\"contacts-view\">\n    {{outlet}}\n</section>\n");